import { TruckDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/truck_events_pb';
import { TruckStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/truck_pb';
import {
  BadgeField,
  Col,
  FieldDisplay,
  IDField,
  ThemeColor,
} from '@rematter/ui-web';

import { truckStatusLabels } from '../enumLabels';

const getStatusColor = (status: TruckStatus): ThemeColor => {
  switch (status) {
    case TruckStatus.AVAILABLE:
      return 'success';
    case TruckStatus.IN_USE:
      return 'teal';
    case TruckStatus.INACTIVE:
      return 'neutral';
    case TruckStatus.OUT_OF_SERVICE:
      return 'warning';
    default:
      return 'neutral';
  }
};

type TruckDeletedDetailProps = {
  event: TruckDeletedEvent;
};

export const TruckDeletedDetail = ({ event }: TruckDeletedDetailProps) => {
  const truck = event.truck;

  if (!truck) {
    return (
      <Col className="@TruckDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@TruckDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Truck
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={truck.id?.value} />
          <FieldDisplay label="License Plate" value={truck.licensePlate} />
          <BadgeField
            label="Status"
            value={truckStatusLabels[truck.status]}
            color={getStatusColor(truck.status)}
          />
          <FieldDisplay label="VIN" value={truck.vin} />
          <FieldDisplay label="Model" value={truck.model} />
          <FieldDisplay
            label="Capacity"
            value={truck.capacity ? String(truck.capacity) : ''}
          />
          <FieldDisplay label="Country" value={truck.country} />
          <FieldDisplay label="State" value={truck.state} />
        </div>
      </Col>
    </Col>
  );
};
